import React from 'react';
import { FormattedPeriod } from '../../../utils/time';
import { IconArrowRightLong } from '../../ui-kit/icons';
import SkillIconList from '../../general/SkillIconList';
import { Table } from '../../ui-kit';
import ScheduleWarning from '../../schedule/ScheduleWarning';

const WarningLevelChange = ({ warning }) => {
  const availabilityRequirement = warning.availability_requirement;

  let availability_requirement_level_before = warning.availability_requirement_level_before;
  let availability_requirement_level_after = warning.availability_requirement_level_after;

  // don't render availability requirement level if they're the same
  if (availability_requirement_level_before?.id === availability_requirement_level_after?.id) {
    availability_requirement_level_before = null;
    availability_requirement_level_after = null;
  }

  // bit ugly, but this data structure must have the shape expected by
  // ScheduleWarning. This shape is defined by the selectors for availability
  // requirements. Instead of changing and simplifying a sensitive component
  // (used by fire control to decide mobilization), we adhere to the expected
  // structure instead.
  let taskAvailabilityCodesBefore = { 1: { availabilityCode: warning.tier_before } };
  let taskAvailabilityCodesAfter = { 1: { availabilityCode: warning.tier_after } };

  // don't render tiers if they're the same
  if (warning.tier_before?.id === warning.tier_after?.id) {
    taskAvailabilityCodesBefore = {};
    taskAvailabilityCodesAfter = {};
  }

  const before = {
    serviceLevel: 'in_service',
    warningLevel: warning.warning_level_before,
    taskAvailabilityCodes: taskAvailabilityCodesBefore,
    availabilityRequirementLevel: availability_requirement_level_before
  };

  const after = {
    serviceLevel: 'in_service',
    warningLevel: warning.warning_level_after,
    taskAvailabilityCodes: taskAvailabilityCodesAfter,
    availabilityRequirementLevel: availability_requirement_level_after
  };

  return (
    <React.Fragment>
      <ScheduleWarning inline availabilityRequirement={availabilityRequirement} availabilityRequirementState={before} />{' '}
      <IconArrowRightLong />{' '}
      <ScheduleWarning inline availabilityRequirement={availabilityRequirement} availabilityRequirementState={after} />
    </React.Fragment>
  );
};

const UnderstaffingWarningTemplate = ({ warnings }) => (
  <Table bordered condensed hover>
    <thead>
      <tr>
        <th>{I18n.t('activerecord.models.user')}</th>
        <th>{I18n.t('attributes.period')}</th>
        <th>{I18n.t('activerecord.attributes.warnings/warning_change.warning_change')}</th>
        <th>{I18n.t('activerecord.attributes.user.skill_icons')}</th>
        <th>{I18n.t('activerecord.models.station.one')}</th>
      </tr>
    </thead>
    <tbody>
      {warnings.map(warning => (
        <tr key={`${warning.start_time}_${warning.end_time}_${warning.availability_requirement.id}`}>
          <td>
            {warning.user?.first_name} {warning.user?.last_name}
          </td>
          <td>
            <FormattedPeriod start={warning.start_time} end={warning.end_time} showNowLabel={false} />
          </td>
          <td>
            <WarningLevelChange warning={warning} />
          </td>
          <td>
            <SkillIconList skills={warning.affected_skills} showScheduleIconsOnly={true} />
          </td>
          <td>{warning.affected_group.name}</td>
        </tr>
      ))}
    </tbody>
  </Table>
);

export default UnderstaffingWarningTemplate;
